import { createSlice } from "@reduxjs/toolkit";

import { STATUS } from "../../../config/constants";

const initialState = {
  isDarkMode: false,
  status: STATUS.NONE,
};

export const darkModeSlice = createSlice({
  name: "darkMode",
  initialState,
  reducers: {
    resetState: (state) => {
      state.status = STATUS.NONE;
      state.data = false;
    },
    readyForNextState: (state) => {
      state.status = STATUS.NONE;
      state.error = undefined;
    },
    request: (state) => {
      state.status = STATUS.FETCHING;
    },
    success: (state, action) => {
      state.status = STATUS.SUCCESS;
      state.isDarkMode = action.payload.isDarkMode;
    },
    failure: (state, action) => {
      const { payload: error } = action;
      state.status = STATUS.FAILURE;
      state.error = error;
    },
  },
});

export const { resetState, readyForNextState, request, success, failure } =
  darkModeSlice.actions;

export const status = (state) => state.darkMode.status;

export const data = (state) => state.darkMode.data;

export const error = (state) => state.darkMode.error;

export default darkModeSlice.reducer;
